import * as React from 'react';

const SvgMoney = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44.73 15.493c-1.003-5.063-4.76-7.28-9.986-7.28H14.257c-6.16 0-10.267 3.08-10.267 10.267v12.017c0 5.18 2.124 8.213 5.624 9.52.513.186 1.073.35 1.656.443.934.21 1.937.303 2.987.303h20.51c6.16 0 10.267-3.08 10.267-10.266V18.48c0-1.097-.094-2.077-.304-2.987ZM12.904 28c0 .957-.794 1.75-1.75 1.75-.957 0-1.75-.793-1.75-1.75v-7c0-.957.793-1.75 1.75-1.75.956 0 1.75.793 1.75 1.75v7ZM24.5 30.66a6.154 6.154 0 0 1-6.16-6.16 6.154 6.154 0 0 1 6.16-6.16 6.154 6.154 0 0 1 6.16 6.16 6.154 6.154 0 0 1-6.16 6.16ZM39.574 28c0 .957-.794 1.75-1.75 1.75-.957 0-1.75-.793-1.75-1.75v-7c0-.957.793-1.75 1.75-1.75.956 0 1.75.793 1.75 1.75v7Z'
      fill='#E00034'
    />
    <path
      d='M52.033 25.48v12.017c0 7.186-4.107 10.29-10.29 10.29H21.256c-1.75 0-3.313-.257-4.666-.77-1.097-.397-2.054-.98-2.824-1.727-.42-.397-.093-1.027.49-1.027h20.487c8.633 0 13.767-5.133 13.767-13.743V18.48c0-.56.63-.91 1.026-.49 1.587 1.68 2.497 4.13 2.497 7.49Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgMoney;
